export const userSelector = (state, userId) => {
  return state.user.items[userId];
};
